import http from './axios'

// 登录
const login = ({ loginName, password }) => {
  return http.json_post('/manager/user/login', {loginName: loginName, password: password })
}

export default login